<script>
export default {
  name: 'field-group-render',
  props: {
    node: Object,
    rowIndex: Number,
    row: Object
  },
  inject: ['pageType'],
  created () {
    if (!this.rowIndex && this.node.pageType === 'detail') {
      this.node.follow = false
    }
  },
  computed: {
    className () {
      return this.requireList.length > 0 ? 'is-required' : ''
    },
    isDetails () {
      return this.node.pageType === 'detail' || this.node.pageType === 'list'
    },
    isTable () {
      return typeof this.rowIndex === 'number'
    },
    styleType () {
      return this.isTable ? 'mini' : 'small'
    },
    isAllText () {
      return this.node.viewContent.every(item => {
        return (item.props.pageReadOnly && item.props.textShow)
      })
    },
    newFollow () {
      const inTableOfDetail = this.isTable && this.node.pageType === 'detail'
      return inTableOfDetail ? true : this.node.follow
    }
  },
  data () {
    return {
      requireList: [],
      textStyle: {
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        display: '-webkit-box',
        webkitLineClamp: 2,
        webkitBoxOrient: 'vertical'
      },
      isTooltip: false
    }
  },
  provide () {
    return {
      isFieldGroup: true
    }
  },
  render (h) {
    const {
      props,
      viewContent = [],
      info: {hiddenName, display, tip, supportBanner}
    } = this.node
    const newViewConent = this.handleDisplay(display, viewContent)
    const newSpan = supportBanner ? {span: '0'} : {}
    const follow = this.newFollow
    return (
      newViewConent.length > 0 ? (
        <sy-form-item
          props={{
            styleType: this.styleType,
            follow,
            ...props,
            pageType: this.pageType,
            hideLabel: hiddenName,
            ...newSpan
          }}
          class='field-group-form-item'
        >
          {
            <span slot='label' class={this.className}>{props.label}: 
              {
                tip &&
                <el-tooltip
                  effect="dark"
                  popperClass="sy-tooltip"
                  content={tip}
                  placement="top-start"
                >
                  <i class="el-icon-warning iconTips"></i>
                </el-tooltip>
              }
            </span>
          }
          <div class='field-group'>
            {(this.isDetails || this.isAllText)  
              ? <el-popover 
                trigger='hover'
                placement="top-start"
                popper-class='popper-color'
                disabled={!this.isTooltip}
              >
                {this.newRender(newViewConent, true)}
                <render
                  slot="reference"
                  ref='fieldGroupInList'
                  class={{'detail-item': (this.isDetails || this.isAllText), 'list-item': this.isTable}}
                  style={this.textStyle}
                  viewContent={newViewConent}
                  rowIndex={this.rowIndex}
                  nativeOnMouseenter={this.handleOver}
                  row={this.row}
                  forceFollow={this.isDetails}
                  attrs={{changeRequired: this.changeRequired}}
                />
              </el-popover> 
              : this.newRender(newViewConent)
            }
          </div>
        </sy-form-item>
      ) : null
    )
  },
  methods: {
    handleOver () {
      const node = this.$refs.fieldGroupInList.$el
      let cHeight = node.clientHeight
      let sHeight = node.scrollHeight
      this.isTooltip = sHeight > (cHeight + 10)
    },
    newRender (newViewConent, popover = false) {
      return <render
        class={{'detail-item': this.isDetails, 'list-item': this.isTable, 'field-group-popover': popover}}
        viewContent={newViewConent}
        rowIndex={this.rowIndex}
        row={this.row}
        forceFollow={this.isDetails}
        attrs={{changeRequired: this.changeRequired}}
      />
    },
    changeRequired (apiName, value) {
      if (value) {
        this.requireList.push(apiName)
      } else {
        this.requireList = this.requireList.filter(v => v !== apiName)
      }
    },
    handleDisplay (display, viewContent) {
      let newDisplay = display.split('#')
      let newView = []
      newDisplay.forEach(word => {
        if (word && word !== 'null') {
          let view = viewContent.find(item => { 
            return word === item.apiName
          })
          if (this.isAllText && view) view.follow = true
          view ? newView.push(view) : newView.push(word)
        }
      })
      return newView
    }
  }
}
</script>
<style scoped lang='scss'>
// 覆盖默认 form-item样式
.is-required::before{
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}
.sy-form-item--top {
  .field-group {
    ::v-deep {
      .detail-item {
        padding-top: 0;
      }
    }
  }
}

.field-group {
  ::v-deep {
    // .field {
    //   margin: 0 8px 8px 8px;
    // }
    .is-pure-text {
      margin: 0;
    }
    .sy-form-item:last-child .field{
      margin-right: 0;
    }
    .sy-form-item:first-child .field{
      margin-left: 0;
    }
    .sy-form-item{
      padding: 0;
      width: 96px;
      .el-form-item {
        width: 100%;
      }
    }
    .hide-label {
      & > .el-form-item__label {
        display: none;
      }
      & > .el-form-item__label-wrap {
        display: none;
      }
    }
  }
}
.field-group {
  ::v-deep {
    .render {
      .render-string{
        vertical-align: 2px;
        display: inline-block;
        padding-top: 6px;
        white-space: pre-wrap;
      }
    }
  }
  .detail-item.render {
    padding-top: 5px;
    ::v-deep {
      .sy-form-item {
        display: inline;
        vertical-align: baseline;
        margin: 0;
        .follow-box {
          .follow-conent {
            display: inline;
          }
          .is-pure-text {
            display: inline;
            padding: 0;
            * {
                display: inline!important;
            }
          }
          font-size: 14px;
          display: inline;
          vertical-align: middle;
          // float: left;
        }
      }
      .render-string{
        display: inline;
        padding-top: 0;
        vertical-align: middle;
        margin: 0;
      }
    }
    ::v-deep .sy-form-item:after {
        content: '';
        height: 0;
        line-height: 0;
        visibility: hidden;
        clear: both;
    }
  }
  .list-item.render {
    padding-top: 0;
    line-height: 14px;
    // word-break: break-all;
    // text-overflow: ellipsis;
    // display: -webkit-box;
    // -webkit-box-orient: vertical;
    // -webkit-line-clamp: 2;
    // overflow: hidden;
    ::v-deep {
      .sy-form-item {
        vertical-align: baseline;
        .follow-box {
          font-size: 12px;
          vertical-align: middle;
        }
      }
      .render-string{
        vertical-align: middle;
      }
    }
  }
}
</style>
<style lang='scss'>
  .field-group-popover{
    text-align: left;
    max-width: 296px;
    .sy-form-item {
      width: auto !important;
      padding: 0!important;
      display: inline;
      line-height: 20px;
      font-size: 12px!important;
      * {
        display: inline!important;
        font-size: 12px!important;
      }
    }
    .field.is-pure-text {
      padding: 0!important;
      color: #fff;
    }
    .render-string{
      white-space: pre-wrap;
      font-size: 12px;
      line-height: 20px;
      vertical-align: 1px;
    }
  } 
  .field-group-popover.list-item {
    .sy-form-item {
      line-height: 20px;
      vertical-align: 0px;
    }
  }
</style>
